import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ViewTypeName } from "@air/api/types";
import { useBreakpointsContext } from "@air/provider-media-query";
import { memo } from "react";
import { useSelector } from "react-redux";
import { MobileToggleNestedItemsButton } from "~/_components/MobileToggleNestedItemsButton";
import { usePublicPermissions } from "~/components/PublicPermissionsProvider";
import { ViewKanbanGroupByMenu } from "~/components/ViewControls/ViewKanbanGroupByMenu/ViewKanbanGroupByMenu";
import { ViewSortingMenu } from "~/components/ViewControls/ViewSortingMenu/ViewSortingMenu";
import { ViewTypeToggleMenu } from "~/components/ViewControls/ViewTypeToggleMenu/ViewTypeToggleMenu";
import { PublicViewVisibilityToggleMenu } from "~/components/ViewControls/ViewVisiblityToggleMenu/PublicViewVisibilityToggleMenu";
import { currentViewTypeNameSelector } from "~/store/configViews/selectors";
import { canSeeBoardCustomFields } from "~/utils/permissions/boardPermissions";
export const PublicBoardHeaderViewControls = /*#__PURE__*/ memo(()=>{
    const currentViewTypeName = useSelector(currentViewTypeNameSelector);
    const inGalleryView = currentViewTypeName === ViewTypeName.gallery;
    const inKanbanView = currentViewTypeName === ViewTypeName.kanban;
    const { isAboveMediumScreen } = useBreakpointsContext();
    const { permissions } = usePublicPermissions();
    const canViewCustomFields = canSeeBoardCustomFields(permissions);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center gap-2",
        children: [
            inKanbanView && canViewCustomFields && /*#__PURE__*/ _jsx(ViewKanbanGroupByMenu, {
                customFieldValues: undefined
            }),
            isAboveMediumScreen && (inGalleryView || inKanbanView) && /*#__PURE__*/ _jsx(ViewSortingMenu, {}),
            !isAboveMediumScreen && /*#__PURE__*/ _jsx(MobileToggleNestedItemsButton, {}),
            isAboveMediumScreen && /*#__PURE__*/ _jsx(PublicViewVisibilityToggleMenu, {}),
            /*#__PURE__*/ _jsx(ViewTypeToggleMenu, {
                canViewCustomFields: canViewCustomFields
            })
        ]
    });
});
PublicBoardHeaderViewControls.displayName = "PublicBoardHeaderViewControls";
